import {Component} from '@lib/Component';
import {ViewportObserver} from '@services/ViewportObserver';

export class WondersFamily extends Component {
  target: HTMLDivElement | undefined = undefined;
  _viewportObserver: ViewportObserver;

  constructor() {
    super();
    this.onMove = this.onMove.bind(this);

    this._viewportObserver = new ViewportObserver({
      margin: '0px',
      ratio: 0.0,
    });
  }

  didMount() {
    this.target = this.element?.querySelector(
      '.s-wonders-family_bg',
    ) as HTMLDivElement;

    this._viewportObserver?.observe(this.element);
    this._viewportObserver.onChange.connect((type) => {
      if (type === 'below' || type === 'above') {
        this.on('mousemove', this.onMove);
      }
      if (type === 'below-pre' || type === 'above-pre') {
        // this.on.removeEventListener('mousemove', this.onMove);
      }
    });
  }

  _move(x: number, y: number) {
    if (this.target) {
      this.target.style.transform = `translate3d(${x}px, ${y}px, 0)`;
    }
  }

  onMove(e: MouseEvent) {
    const t = 100;
    const {offsetWidth = 0, offsetHeight = 0} = this.element || {};
    const x = offsetWidth - e.clientX * 2;
    const y = offsetHeight - e.clientY * 2;
    this._move(x / t, y / t);
  }
}
